import { getSession, type StoredSession } from './session-store';

/**
 * True when the CRM runs inside Dale Negocios, the iPhone app. The browser
 * always signs in with a cookie; only the app hands the CRM a bearer session,
 * and its web view (WKWebView) carries no "Safari/" token. Apple lets a free
 * companion app skip in-app purchase only if it neither sells nor points to a
 * way to pay, so inside the app the CRM hides the plan, its prices and the card.
 */
export function insideNativeApp(
  session: Pick<StoredSession, 'transport'> | null | undefined = getSession(),
  userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): boolean {
  return session?.transport === 'bearer' && /\b(iPhone|iPad|iPod)\b/.test(userAgent) && !userAgent.includes('Safari/');
}
